/** Render a minor-unit price (cents) as a localized currency string. */
export function formatPrice(cents: number, currency = "USD"): string {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

export function Price({ cents, currency }: { cents: number; currency?: string }) {
  return <span className="font-mono tabular-nums">{formatPrice(cents, currency)}</span>;
}
